import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { TextFieldCPF } from '../../../shared/TextFieldCPF';
import { ReactComponent as AlertIcon } from '../../../../images/alert.svg';
import { SignInVerification } from '../../../../entities/SignInMethod';
import CpfStepViewModel from './viewModel';
import { Actions, ContinueButton, ErrorIcon, FieldInput, FieldWrapper, Label, Message, RequestCodeButton } from './styled';

type CpfStepProps = {
  onUserVerified: (data: SignInVerification) => void;
  onLoadingChange: (isLoading: boolean) => void;
  onContinueWithoutLogin?: () => void;
};

export default function CpfStep({ onUserVerified, onLoadingChange, onContinueWithoutLogin }: CpfStepProps) {
  const {
    form,
    hasError,
    isLoading,
    requestCodeLabel,
    isRequestCodeDisabled,
    onCpfChange,
    onValidityChange,
    handleRequestCode,
    handleContinueWithoutLogin
  } = CpfStepViewModel({ onUserVerified, onLoadingChange, onContinueWithoutLogin });

  return (
    <>
      <Message>Para te ajudar com essa questão, preciso que acesse a sua conta:</Message>

      <FieldWrapper>
        <Label>CPF*</Label>
        <FieldInput>
          <TextFieldCPF form={form} name="oyana.cpf" onValidityChange={onValidityChange} onChange={onCpfChange} />
          {hasError && (
            <ErrorIcon>
              <AlertIcon />
            </ErrorIcon>
          )}
        </FieldInput>
      </FieldWrapper>

      <Actions>
        <RequestCodeButton
          variant="contained"
          loading={isLoading}
          loadingPosition="end"
          disabled={isRequestCodeDisabled}
          onClick={handleRequestCode}
          endIcon={<ArrowForwardIcon />}
        >
          {requestCodeLabel}
        </RequestCodeButton>

        <ContinueButton variant="inline" color="primary" onClick={handleContinueWithoutLogin}>
          Continuar sem login
        </ContinueButton>
      </Actions>
    </>
  );
}
